import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const requiredWhenValidator =
  (ctrl: string, dependant: string, value: unknown): ValidatorFn =>
  (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) {
      return null;
    }

    const control = group.get(ctrl);
    const dependantControl = group.get(dependant);

    if (!control || !dependantControl) {
      return null;
    }

    let isRequired = false;
    if (!dependantControl.value) {
      isRequired = false;
    } else if (Array.isArray(dependantControl.value)) {
      isRequired = dependantControl.value.includes(value);
    } else {
      isRequired = dependantControl.value === value;
    }
    const isEmpty =
      control.value === null || control.value === undefined || control.value === '' || (Array.isArray(control.value) && control.value.length === 0);

    if (isRequired && isEmpty) {
      control.setErrors({ required: true });
    } else {
      if (control.hasError('required')) {
        const errors = { ...control.errors };
        delete errors['required'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    }

    return null;
  };
